import React from 'react';
import { Box, Grid, IconButton, Tooltip, Typography } from 'components/mui';
import RefreshIcon from '@mui/icons-material/Refresh';
import CaseCommentsTable from 'containers/pages/comments/components/caseTable/CaseCommentsTable';
import CaseCommentManager from 'containers/pages/comments/components/caseTable/CaseCommentManager';
import CaseSearch from 'containers/pages/cases/components/caseSearch/CaseSearch';
import CommentFilterBar from 'containers/pages/comments/components/commentFilterBar/CommentFilterBar';
import LoadingBackdrop from 'components/LoadingBackdrop';
import useCommentsDashboard from 'containers/pages/comments/hooks/useCommentsDashboard';

function CommentsDashboard() {
	const { state, handler } = useCommentsDashboard();

	return (
		<Box
			component="main"
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: 2,
				p: { xs: 2, sm: 3 },
			}}
		>
			{/* Header */}
			<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
				<Typography variant="h5" component="h1">
					Comments
				</Typography>
				<Tooltip title="Refresh">
					<span>
						<IconButton onClick={handler.onRefresh} disabled={state.isLoading}>
							<RefreshIcon />
						</IconButton>
					</span>
				</Tooltip>
			</Box>

			{/* Search bar */}
			<Grid container alignItems="stretch" spacing={2} wrap="nowrap" sx={{ mb: 1 }}>
				<Grid item xs>
					<Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
						<CaseSearch
							searchInput={state.searchInput}
							onSearchInput={handler.onSearchInput}
							onReset={handler.onResetSearch}
						/>
					</Box>
				</Grid>
			</Grid>

			{/* Filter bar */}
			<CommentFilterBar
				filters={state.filters}
				onFilterChange={handler.onFilterChange}
				onApplyFilters={handler.onApplyFilters}
				onClearFilters={handler.onClearFilters}
			/>

			{/* New comment manager */}
			<CaseCommentManager
				setComments={handler.setComments}
				commentToCopy={state.commentToCopy}
				resetCommentToCopy={handler.resetCommentToCopy}
			/>

			{/* Comments table */}
			<CaseCommentsTable
				comments={state.comments}
				loadingComments={state.isLoading}
				showDecimalFormat
				setComments={handler.setComments}
				onCopyCommentClick={handler.handleCopyComment}
				page={state.page}
				totalResults={state.totalResults}
				rowsPerPage={state.rowsPerPage}
				onPageChange={handler.onPageChange}
			/>

			<LoadingBackdrop open={state.isLoading && state.comments.length === 0} />
		</Box>
	);
}

export default CommentsDashboard;
